import * as React from "react"
export const IconShapeRectangleSoftEdges = (props) => {
    const fill = props?.fill || '#202020';
    return <svg width="30" height="30" viewBox="0 0 30 30" fill={fill} xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" strokeWidth="0" d="M25 6C25 5.44772 24.5523 5 24 5H15C9.47715 5 5 9.47715 5 15V24C5 24.5523 5.44772 25 6 25C6.55228 25 7 24.5523 7 24V15C7 10.5817 10.5817 7 15 7H24C24.5523 7 25 6.55228 25 6Z" />
    </svg>
}
export default IconShapeRectangleSoftEdges;